import { styled } from "@mui/material";

export const TooltipTeachersContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.contrastText,
  maxWidth: "17.5rem",
  borderRadius: "0.5rem",
  boxShadow: "0.125rem 0.125rem 0.75rem rgb(0 0 0 / 11%)",
  border: `0.063remsolid ${theme.palette.custom.grey["emenu-tile-active"]}`,
}));
